import { Tooltip } from '../../../../components/Tooltip/Tooltip'
import { ReactComponent as InfoIcon } from 'assets/svg/Information.svg'
import { ReactComponent as ArrowIcon } from 'assets/svg/ArrowIcon.svg'
import { AlignType } from 'rc-table/lib/interface'
import { TOOLTIP } from '../../../../constants'

export const columns = (canSeeCommunitySplit: boolean) => [
  {
    dataIndex: 'health_system_name',
    key: 'health_system_name',
    title: canSeeCommunitySplit ? 'CO&HS' : 'HS',
    width: '40%',
    render: (_, { health_system_name }) => <>{health_system_name}</>
  },
  {
    dataIndex: 'gpo_retain',
    key: 'gpo_retain',
    align: 'right' as AlignType,
    title: (
      <Tooltip title={TOOLTIP.GPO_ALLOCATION}>
        <InfoIcon className="info-icon" /> GPO allocation,%
      </Tooltip>
    ),
    render: (_, { gpo_retain, second_row }) => {
      if (second_row) return null
      if (!gpo_retain) return '---'
      return <>{gpo_retain}%</>
    }
  },
  {
    dataIndex: 'remaining_to_be_distributed',
    key: 'remaining_to_be_distributed',
    title: 'Remaining to be distributed',
    align: 'right' as AlignType,
    className: 'grey-row',
    render: (_, { remaining_to_be_distributed, second_row }) => {
      if (second_row) return <ArrowIcon key={Math.random()} />
      if (!remaining_to_be_distributed) return '---'
      return <>{remaining_to_be_distributed}%</>
    }
  },
  ...(canSeeCommunitySplit
    ? [
        {
          dataIndex: 'community_split',
          key: 'community_split',
          align: 'right' as AlignType,
          title: (
            <Tooltip title={TOOLTIP.CO_SPLIT}>
              <InfoIcon className="info-icon" /> CO retain,%
            </Tooltip>
          ),
          render: (_, { community_split, second_row }) => {
            if (!second_row) return null
            if (!community_split) return '---'
            return <>{community_split}%</>
          }
        }
      ]
    : []),
  {
    dataIndex: 'hs_split',
    key: 'hs_split',
    align: 'right' as AlignType,
    title: (
      <Tooltip title={TOOLTIP.HS_SPLIT}>
        <InfoIcon className="info-icon" /> HS split,%
      </Tooltip>
    ),
    render: (_, { hs_split, second_row }) => {
      if (!second_row) return null
      if (!hs_split) return '---'
      return <>{hs_split}%</>
    }
  }
]
